export default __webpack_public_path__ + "static/media/relationHOTo.82c83d46.svg";